import React, { useMemo } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

import { CellSkeleton, CircleSkeleton, HeaderSkeletonRoot, useStyles } from './styles';

const CARD_ROWS = 6;
const SKELETON_HEADER_KEYS = [0, 1, 2, 3, 4];

export const SkeletonList = ({ rows = 10 }) => {
  const classes = useStyles();

  const seed = useMemo(() => Math.random().toString(36).substr(2, 9), []);
  const rowKeys = useMemo(
    () => Array.from({ length: Math.max(0, rows) }, (_, i) => `row-${seed}-${i}`),
    [rows, seed]
  );

  return (
    <>
      <HeaderSkeletonRoot elevation={0} role="progressbar">
        {SKELETON_HEADER_KEYS.map(id => (
          <CellSkeleton key={`header-cell-${id}`}>
            <CircleSkeleton variant="circle" width={20} height={20} />
            <Skeleton variant="rect" width="70%" height={20} />
          </CellSkeleton>
        ))}
      </HeaderSkeletonRoot>

      <div className={classes.rowsContainer} role="progressbar">
        {rowKeys.map(each => (
          <div key={each} className={classes.skeletonRow}>
            {SKELETON_HEADER_KEYS.map(e => (
              <div key={e} className={classes.skeletonItemContainer}>
                <Skeleton height={10} className={classes.skeletonItem} />
              </div>
            ))}
          </div>
        ))}
      </div>
      {rows >= CARD_ROWS && (
        <div className={classes.footerSkeletonBar}>
          <Skeleton width="100%" height={56} color="A200" />
        </div>
      )}
    </>
  );
};
